export default __webpack_public_path__ + "static/0247-6c53910e8f4b9fa63e3146dd5220182f.png";